module.exports = __webpack_public_path__ + "static/media/resfeberDemoSm.b260a1c5.gif";